// @flow
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styles from './CardStatusBanner.module.scss';

type Props = {
    accountInGoodStanding: boolean,
    bidderHasBid: boolean,
    bidderHasHighBid: boolean,
    blockedByAuctioneer: boolean,
    isAvailable: boolean,
    isPassed: boolean,
    isReserveMet: boolean,
    pending: boolean,
    suspended: boolean,
};

const CardStatusBanner = (props: Props) => {
    const {
        accountInGoodStanding,
        bidderHasBid = false,
        bidderHasHighBid = false,
        blockedByAuctioneer = false,
        isAvailable = false,
        isPassed = false,
        isReserveMet = false,
        pending = false,
        suspended = false,
    } = props;

    let banner = null;
    let bannerClass = '';

    if (blockedByAuctioneer || suspended || !accountInGoodStanding) {
        banner = <FormattedMessage id="account_suspended" />;
        bannerClass = styles.pending;
    } else if (isAvailable) {
        if (bidderHasHighBid && isReserveMet) {
            if (pending) {
                banner = <FormattedMessage id="registration_pending" />;
                bannerClass = styles.pending;
            } else {
                banner = <FormattedMessage id="you_are_leading" />;
                bannerClass = styles.leading;
            }
        } else if (bidderHasHighBid && !isReserveMet) {
            banner = <FormattedMessage id="reserve_not_met" />;
            bannerClass = styles.warning;
        } else if (bidderHasBid && !bidderHasHighBid) {
            banner = <FormattedMessage id="outbid" />;
            bannerClass = styles.warning;
        }
    } else if (isPassed) {
        if (pending) {
            banner = <FormattedMessage id="not_approved" />;
            bannerClass = styles.pending;
        } else {
            banner = <FormattedMessage id="lot_passed" />;
            bannerClass = styles.warning;
        }
    } else if (bidderHasHighBid) {
        banner = <FormattedMessage id="you_won" />;
        bannerClass = styles.leading;
    } else if (bidderHasBid) {
        banner = <FormattedMessage id="lost" />;
        bannerClass = styles.warning;
    }

    const classes = classNames(styles['bid-status'], bannerClass);

    return !bidderHasBid && !isAvailable ? null : <div className={classes}>{banner}</div>;
};

export default React.memo<Props>(CardStatusBanner);
